'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
* A utility class that allows you to place elements directly on the body of the document, instead of placed
*   normally in the DOM. Useful for Modals, Popups, and other elements that need absolute screen positioning.
* See http://joecritchley.svbtle.com/portals-in-reactjs for the Portal concept
*/

var Portal = _react2['default'].createClass({
    displayName: 'Portal',


    propTypes: {
        'rerenderOnUpdate': _react2['default'].PropTypes.bool, // For dynamic components
        'className': _react2['default'].PropTypes.string // Optionally, creates a div to with specified class to wrap child components
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'rerenderOnUpdate': false,
            'className': null
        };
    },
    componentDidMount: function componentDidMount() {
        this.element = document.createElement('div');
        document.body.appendChild(this.element);
        this._renderLayer();
    },


    // FIXME: This should be filled in to adapt to property changes
    componentWillReceiveProps: function componentWillReceiveProps() {},
    componentDidUpdate: function componentDidUpdate() {
        if (this.props.rerenderOnUpdate) {
            this._renderLayer();
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        _reactDom2['default'].unmountComponentAtNode(this.element);
        document.body.removeChild(this.element);
    },
    _renderLayer: function _renderLayer() {
        if (this.props.className) {
            _reactDom2['default'].render(_react2['default'].createElement(
                'div',
                { className: this.props.className },
                this.props.children
            ), this.element);
        } else {
            _reactDom2['default'].render(this.props.children, this.element);
        }
    },


    // Placeholder to satisfy render
    render: function render() {
        return null;
    }
});

module.exports = Portal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/portal.jsx
 ** module id = 804
 ** module chunks = 0 1
 **/